import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions, RequestMethod } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class PDFService {
    headers: Headers;
    baseAPIurl = '';

    constructor(private _http: Http, private _httpClient: HttpClient) {
        this.baseAPIurl = environment.baseAPIUrl;
    }

    getToken() {
        debugger;
        const token = localStorage.getItem('AccessToken');
        if (token != null) {
            const bearerToken = 'Bearer ' + token;
            let newHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
            newHeaders = newHeaders.append('Authorization', bearerToken);

            return newHeaders;
        }
    }

    GetHTMLString(OrderId: string, EmailId: string): Observable<any> {
        debugger;
        return this._httpClient.get(this.baseAPIurl +
            'Pdf/GetHTMLStrings?OrderId=' + OrderId + '&EmailId=' + EmailId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server error');
    }
}
